<template>
  <div class="alarm">
    <div class="echart" ref="refEchart"></div>
    <AlarmTable :visible.sync="alarmShow" :id="id" />
  </div>
</template>
<script>
import * as echarts from 'echarts';
import AlarmTable from './AlarmTable.vue';
export default {
  name:'alarmCard',
  components:{
    AlarmTable
  },
  data(){
    return {
      myChart:null,
      id:null,
      alarmShow:false,
    }
  },
  mounted(){

  },
  methods: {
    async getData(){
      try{
        const { data, msg, code } = await this.$API.getStatisticsAlarmNum();
        if(code !== 0) throw { msg };
        console.log(this.$refs.refEchart,'this.$refs.refEchart')
        this.init(data);
      }catch(err){
        console.error(err);
      }
    },
    init(data){
      this.myChart = echarts.init(this.$refs.refEchart);
      this.myChart.setOption(this.getOption(data));
      this.myChart.on('click',e => {
        this.id = e.data.alarmType;
        this.alarmShow = true;
      });
      window.addEventListener("resize", () => { this.myChart?.resize();});
      this.myChart?.resize();
    },
    getOption(data){
      return {
        title: {
          show:false
        },
        tooltip: {
          trigger: 'item',
          formatter(val){
            return `${val.marker}${val.name}`
          }
        },
        legend: {
          width:'20%',
          orient: "vertical",
          right:'0',
          bottom:'2%',
          textStyle:{
            color:'#FFF'
          },
        },

        color:['#65B6F3','#D55821','#F1AA30','#36B25B','#316AF6','#7B7C80','rgba(8,197,164,1)','rgba(198,91,33,1)','rgba(35,103,226,1)'],
        series: [
          {
            name: '',
            type: 'pie',
            center:['30%','50%'],
            radius: '65%',
            data: data.map(item => ({ name:`${item.alarmTypeName}:${item.num}个`, value:item.num, ...item })),
            labelLine:{
              show:false
            },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
    },
  },
  activated() {
    this.$nextTick(() => {
      this.getData();
    });
  },
}
</script>
<style lang="scss" scoped>
.alarm{
  width: 100%;
  height: 100%;
  .echart{
    width: 100%;
    height: 100%;
  }
}
</style>
